import {
  DropdownMenuItem,
  Icon,
  DropdownMenuSeparator,
  Flex,
} from '@kognitos/lattice';
import { NavLink, useNavigate } from 'react-router-dom';
import type { IDropdownMenuItem } from './types';
import { HotkeyTrigger } from '@/shared/components/HotkeyTrigger';

const DropdownMenuItems = ({ items }: { items: IDropdownMenuItem[] }) => {
  const navigate = useNavigate();
  return (
    <>
      {items.map((item, index) => {
        const onHotkeyPress = () => {
          if (item.url) {
            navigate(item.url);
          }
          if (item.onClick) {
            item.onClick();
          }
        };

        if (item.type === 'separator') {
          return <DropdownMenuSeparator key={item.key} />;
        }

        return (
          <DropdownMenuItem
            key={item.title || `item-${index}`}
            onClick={item.disabled ? undefined : item.onClick}
            className={item.url ? 'p-0' : ''}
            disabled={item.disabled}
          >
            {item.url ? (
              <NavLink
                to={item.url}
                className="px-2 py-1.5 w-full"
                target={item.isExternalUrl ? '_blank' : undefined}
                rel={item.isExternalUrl ? 'noopener noreferrer' : undefined}
                onClick={
                  item.disabled
                    ? e => {
                        e.preventDefault();
                      }
                    : undefined
                }
              >
                <Flex align="center">
                  {item.icon && (
                    <Icon type={item.icon} className="mr-2 h-4 w-4" />
                  )}
                  <span>{item.title}</span>
                  {item.shortcut && item.onClick && !item.disabled && (
                    <HotkeyTrigger
                      shortcut={item.shortcut}
                      onHotkeyPress={onHotkeyPress}
                    />
                  )}
                </Flex>
              </NavLink>
            ) : (
              <>
                {item.icon && <Icon type={item.icon} className="h-4 w-4" />}
                <span>{item.title}</span>
                {item.shortcut && item.onClick && !item.disabled && (
                  <HotkeyTrigger
                    shortcut={item.shortcut}
                    onHotkeyPress={onHotkeyPress}
                  />
                )}
              </>
            )}
          </DropdownMenuItem>
        );
      })}
    </>
  );
};

export default DropdownMenuItems;
